import { AuthSession, LoginCredentials, MeResponse } from '@/types';
import { apiClient } from '../client';

export async function login(credentials: LoginCredentials): Promise<AuthSession> {
  const { data } = await apiClient.post<AuthSession>('/auth/login', credentials);
  return data;
}

/** Reads the httpOnly `pert_refresh_token` cookie server-side — no body needed. Also rotates the cookie. */
export async function refresh(): Promise<AuthSession> {
  const { data } = await apiClient.post<AuthSession>('/auth/refresh');
  return data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function me(): Promise<MeResponse> {
  const { data } = await apiClient.get<MeResponse>('/auth/me');
  return data;
}

export async function health(): Promise<{ status: string; service: string }> {
  const { data } = await apiClient.get<{ status: string; service: string }>('/health');
  return data;
}
